<template>
    <FullCalendar :events="events" :plugins="calendarPlugins" :selectAllow="selectAllow" @select="selected"
                  defaultView="dayGridMonth" ref="fullCalendar" selectable="true"/>
</template>

<script>
    import FullCalendar from '@fullcalendar/vue'
    import dayGridPlugin from '@fullcalendar/daygrid'
    import interactionPlugin from '@fullcalendar/interaction'

    export default {

        name: "AvailabilityCalendar",

        props: {
            events: Array,
            standName: String,
            storeName: String,
            user: Object,
            registerUrl: String
        },

        components: {
            FullCalendar
        },

        data() {
            return {
                calendarPlugins: [dayGridPlugin, interactionPlugin],
                calendarAPI: null,
                calendarEvents: this.events
            }
        },

        mounted() {
            this.calendarAPI = this.$refs.fullCalendar.getApi();
        },

        methods: {
            selectAllow: function (info) {
                let startResult = false, endResult = false;

                $.each(this.calendarAPI.getEvents(), function (i, event) {
                    if (moment(event.start).isSame(info.start) && event.rendering === "background") startResult = true; // Iff a background event

                    if (moment(event.start).isSame(moment(info.end).subtract(1, 'day')) && event.rendering === "background") endResult = true; // Iff a background event
                });

                return startResult && endResult;
            },

            selected: function (info) {
                console.log(info);
                // To reference inside callbacks, etc
                let component = this;

                let date = moment(info.start), startDate = moment(info.start), endDate = moment(info.end), events = [];

                while (moment(date).isBefore(endDate)) {

                    $.each(this.calendarAPI.getEvents(), function (i, event) {
                        if (moment(date).isSame(event.start)) {
                            events.push({'id': event.id, 'date': event.start});
                        }
                    });

                    date.add(1, 'day');
                }

                endDate = endDate.subtract(1, 'day');

                bootbox.confirm({
                    title: 'Register Interest',
                    message: 'Would you like to register interest in ' + this.storeName + ' - ' + this.standName + ' (' + startDate.format('DD/MM/YYYY') + ' - ' + endDate.format('DD/MM/YYYY') + ')',
                    buttons: {
                        confirm: {
                            label: 'Yes, Register Interest',
                            className: 'btn-success'
                        },
                        cancel: {
                            label: 'Cancel',
                        }
                    },
                    callback: function (result) {
                        if (result && component.user === null) {

                            Cookies.set('availabilities', {
                                'events': events,
                                'startDate': startDate.format('DD/MM/YYYY'),
                                'endDate': endDate.format('DD/MM/YYYY'),
                                'storeName': component.storeName,
                                'standName': component.standName
                            });

                            window.location = component.registerUrl;
                        } else if (component.user !== null) {
                            console.log('logged in, do something');
                        }
                    }
                });
            }
        }
    };
</script>
